import { render, staticRenderFns } from "./VMultiselect.vue?vue&type=template&id=880c0a0c&scoped=true"
import script from "./VMultiselect.vue?vue&type=script&lang=js"
export * from "./VMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880c0a0c",
  null
  
)

export default component.exports